import classnames from 'classnames';
import { forwardRef } from 'react';

import { Button } from '@/core/tamagoshi/Button/Button';
import { ManomanoProLogo } from '@/core/tamagoshi/Logos/ManomanoProLogo/ManomanoProLogo';
import { Text } from '@/core/tamagoshi/Text/Text';
import { PLATFORMS } from '@/domains/core/settings/constants';
import { getPlatform } from '@/domains/core/settings/utils';
import { footerB2cConnectProLink } from '@/domains/retention/Footer/translations';

import type { B2BTouchpointProps } from '../interfaces';
import { cta, text2, text3 } from '../translations';

import styles from './B2BTouchpointB.module.scss';

const stepperClassnames = {
  [PLATFORMS.FRANCE]: styles.stepperFR,
  [PLATFORMS.GERMANY]: styles.stepperDE,
  [PLATFORMS.GREAT_BRITAIN]: styles.stepperGB,
  [PLATFORMS.ITALY]: styles.stepperIT,
  [PLATFORMS.SPAIN]: styles.stepperES,
};

export const B2BTouchpointLayout = forwardRef<
  HTMLDivElement,
  B2BTouchpointProps
>(({ classNames, onClick, isLayoutInspirational }, ref) => (
  <div
    className={classnames(
      classNames,
      isLayoutInspirational
        ? styles.b2bTouchpoint1column
        : styles.b2bTouchpoint,
    )}
    ref={ref}
    data-testid="b2b-touchpoint"
  >
    <div className={styles.logo}>
      <ManomanoProLogo
        height="35"
        width="193"
        theme="dark"
        className={styles.logoDark}
      />
      <Text tag="p" className={styles.text} weight="bold">
        {text2}
      </Text>
    </div>

    <div className={styles.block1}>
      <Text tag="span" className={styles.subtitle}>
        {text3}
      </Text>
      <div className={styles.stepperWrapper}>
        <div
          className={classnames(
            styles.stepper,
            stepperClassnames[getPlatform()],
          )}
        />
      </div>
    </div>

    <div className={styles.block2}>
      <Button
        href={footerB2cConnectProLink}
        onClick={onClick}
        data-testid="button-go-to-b2b-signup"
      >
        <Text tag="span" className={styles.cta} weight="semiBold">
          {cta}
        </Text>
      </Button>
    </div>
  </div>
));
